import SingleSearchResultContainer from './SingleSearchResultContainer';
export default SingleSearchResultContainer;
